import { APIRuntimeBuilder } from '@cian/mf-registry/browser';

import {
  IOpenAuthModalParameters as IOpenAuthModalParametersV2,
  openAuthModalHandler as openAuthModalHandlerV2,
} from '../apiV2/open-auth-modal';
import {
  ISetRegionIdParameters as ISetRegionIdParametersV2,
  setRegionIdHandler as setRegionIdHandlerV2,
} from '../apiV2/set-region-id';
import { updateHeaderHandler as updateHeaderHandlerV2 } from '../apiV2/update-header';

import {
  IOpenAuthModalParameters as IOpenAuthModalParametersV3,
  openAuthModalHandler as openAuthModalHandlerV3,
} from '../apiV3/open-auth-modal';
import {
  ISetRegionIdParameters as ISetRegionIdParametersV3,
  setRegionIdHandler as setRegionIdHandlerV3,
} from '../apiV3/set-region-id';
import { updateHeaderHandler as updateHeaderHandlerV3 } from '../apiV3/update-header';

import { TReduxStore } from '../../../shared/types/redux';

export function buildAPIRuntime(store: TReduxStore): APIRuntimeBuilder {
  return [
    {
      path: '/v2/open-auth-modal/',
      handler: async (parameters: IOpenAuthModalParametersV2) => openAuthModalHandlerV2(store, parameters),
    },
    {
      path: '/v2/set-region-id/',
      handler: async (parameters: ISetRegionIdParametersV2) => setRegionIdHandlerV2(store, parameters),
    },
    {
      path: '/v2/update-header/',
      handler: async () => updateHeaderHandlerV2(store),
    },
    {
      path: '/v3/open-auth-modal/',
      handler: async (parameters: IOpenAuthModalParametersV3) => openAuthModalHandlerV3(store, parameters),
    },
    {
      path: '/v3/set-region-id/',
      handler: async (parameters: ISetRegionIdParametersV3) => setRegionIdHandlerV3(store, parameters),
    },
    {
      path: '/v3/update-header/',
      handler: async () => updateHeaderHandlerV3(store),
    },
  ];
}
